import { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const GHOST_ID = 13;


export default function ReservationsPage() {
  const [reservations, setReservations] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterSpot, setFilterSpot] = useState("");
  const [filterStart, setFilterStart] = useState("");
  const [filterEnd, setFilterEnd] = useState("");
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({});
  const [apartments, setApartments] = useState([]);


  async function deleteReservation(id) {
    const confirmDelete = window.confirm("Are you sure you want to delete this reservation?");
    if (!confirmDelete) return;

    const { error } = await supabase
      .from("reservations")
      .delete()
      .eq("id", id);

    if (error) {
      alert("Error deleting reservation: " + error.message);
    } else {
      fetchReservations();
    }
  }

  function startEdit(reservation) {
    setEditId(reservation.id);
    setEditData({
      spot_id: reservation.spot_id,
      reserved_by: reservation.reserved_by || "",
      last_name: reservation.last_name || "",
      license_plate: reservation.license_plate || "",
      start_date: reservation.start_date || "",
      end_date: reservation.end_date || "",
      total_price: reservation.total_price || 0,
      apartment_id: reservation.apartment_id ?? "",
    });
  }

  async function saveEdit(id) {
    const start = dayjs(editData.start_date).format("YYYY-MM-DD");
    const end = dayjs(editData.end_date).format("YYYY-MM-DD");
    const totalPrice = Number(editData.total_price);

    const { error } = await supabase
      .from("reservations")
      .update({
        reserved_by: editData.reserved_by,
        last_name: editData.last_name,
        license_plate: editData.license_plate,
        start_date: start,
        end_date: end,
        total_price: totalPrice,
        manual_override: true,
        apartment_id: editData.apartment_id ? Number(editData.apartment_id) : null,
      })
      .eq("id", id);

    if (error) {
      alert("Error updating reservation: " + error.message);
    } else {
      setEditId(null);
      fetchReservations();
    }
  }

  useEffect(() => {
    fetchReservations();
  }, []);

  async function fetchReservations() {
  const { data, error } = await supabase
    .from("reservations")
    .select("id, spot_id, reserved_by, last_name, license_plate, start_date, end_date, total_price, booking_type, apartment_id")
    .neq("spot_id", GHOST_ID)
    .order("start_date", { ascending: true });

  if (!error) setReservations(data || []);
}
useEffect(() => {
  fetchApartments();
}, []);

async function fetchApartments() {
  const { data, error } = await supabase
    .from("apartments")
    .select("id, name, active")
    .eq("active", true)
    .order("name", { ascending: true });

  if (error) console.error("fetchApartments error:", error.message);
  setApartments(data || []);
}

  return (
    <div style={{ padding: 20, fontFamily: "sans-serif" }}>
      <style>
        {`
          @media (max-width: 768px) {
            .filters {
              display: flex;
              flex-direction: column;
              gap: 10px;
            }

            .responsive-table {
              overflow-x: auto;
              width: 100%;
            }

            .responsive-table table {
              min-width: 850px;
              width: 100%;
              border-collapse: collapse;
            }

            .responsive-table th,
            .responsive-table td {
              padding: 10px;
              text-align: left;
              font-size: 14px;
            }

            .responsive-table button {
              margin-right: 5px;
              font-size: 14px;
            }

            input[type="text"],
            input[type="date"],
            input[type="number"] {
              font-size: 14px;
              padding: 4px;
            }
          }
        `}
      </style>

      <h1>All Reservations</h1>

      <div className="filters" style={{ marginBottom: 20 }}>
        <input
          placeholder="Search name..."
          value={filterName}
          onChange={(e) => setFilterName(e.target.value)}
        />
        <input
          placeholder="Spot ID..."
          value={filterSpot}
          onChange={(e) => setFilterSpot(e.target.value)}
        />
        <input
          type="date"
          value={filterStart}
          onChange={(e) => setFilterStart(e.target.value)}
        />
        <input
          type="date"
          value={filterEnd}
          onChange={(e) => setFilterEnd(e.target.value)}
        />
      </div>

      <button
        onClick={() => {
          setFilterName("");
          setFilterSpot("");
          setFilterStart("");
          setFilterEnd("");
        }}
        style={{
          marginBottom: "20px",
          padding: "8px 12px",
          cursor: "pointer"
        }}
      >
        Reset Filters
      </button>

      <div className="responsive-table">
        <table border="1" cellPadding="30">
          <thead>
            <tr>
              <th>Spot</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>License Plate</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Total Price (€)</th>
              <th>Booking Type</th>
              <th>Apartment</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {reservations
              .filter((r) => {
  // normalize the text query once
  const q = filterName.trim().toLowerCase();

  // Name filter: always compare strings (fallback to "")
  const matchesName =
    q === "" ||
    (r.reserved_by ?? "").toLowerCase().includes(q) ||
    (r.last_name ?? "").toLowerCase().includes(q);

  // Spot filter: convert to string safely (fallback to "")
  const matchesSpot =
    filterSpot.trim() === "" ||
    String(r.spot_id ?? "").includes(filterSpot.trim());

  // Date filters: only compare if the reservation date exists
  const matchesStart =
    filterStart === "" ||
    (r.start_date && dayjs(r.start_date).isSameOrAfter(filterStart));

  const matchesEnd =
    filterEnd === "" ||
    (r.end_date && dayjs(r.end_date).isSameOrBefore(filterEnd));

  return matchesName && matchesSpot && matchesStart && matchesEnd;
})

              .map((r) => (
                <tr
                  key={r.id}
                  style={{
                    backgroundColor: r.booking_type === "long-term" ? "#fbeec1" : "white"
                  }}
                >
                  <td>{r.spot_id}</td>
                  <td>
                    {editId === r.id ? (
                      <input
                        value={editData.reserved_by}
                        onChange={(e) =>
                          setEditData({ ...editData, reserved_by: e.target.value })
                        }
                      />
                    ) : (
                      r.reserved_by
                    )}
                  </td>
                  <td>
                    {editId === r.id ? (
                      <input
                        value={editData.last_name}
                        onChange={(e) =>
                          setEditData({ ...editData, last_name: e.target.value })
                        }
                      />
                    ) : (
                      r.last_name
                    )}
                  </td>
                  <td>
                    {editId === r.id ? (
                      <input
                        value={editData.license_plate}
                        onChange={(e) =>
                          setEditData({ ...editData, license_plate: e.target.value })
                        }
                      />
                    ) : (
                      r.license_plate
                    )}
                  </td>
                  <td>
                    {editId === r.id ? (
                      <input
                        type="date"
                        value={editData.start_date}
                        onChange={(e) =>
                          setEditData({ ...editData, start_date: e.target.value })
                        }
                      />
                    ) : (
                      dayjs(r.start_date).format("DD MMM YYYY")
                    )}
                  </td>
                  <td>
                    {editId === r.id ? (
                      <input
                        type="date"
                        value={editData.end_date}
                        onChange={(e) =>
                          setEditData({ ...editData, end_date: e.target.value })
                        }
                      />
                    ) : (
                      dayjs(r.end_date).format("DD MMM YYYY")
                    )}
                  </td>
                  <td>
                    {editId === r.id ? (
                      <input
                        type="number"
                        value={editData.total_price}
                        onChange={(e) =>
                          setEditData({ ...editData, total_price: e.target.value })
                        }
                        style={{ width: "100px" }}
                      />
                    ) : (
                      r.total_price != null
                        ? `€${Number(r.total_price).toFixed(2)}`
                        : ""
                    )}
                  </td>
                  <td>{r.booking_type === "long-term" ? "Long-term" : "Short-term"}</td>
                  <td>
  {editId === r.id ? (
    <select
      value={editData.apartment_id || ""}
      onChange={(e) =>
        setEditData({
          ...editData,
          apartment_id: e.target.value ? Number(e.target.value) : null,
        })
      }
    >
      <option value="">None</option>
      {apartments.map((a) => (
        <option key={a.id} value={a.id}>
          {a.name}
        </option>
      ))}
    </select>
  ) : (
    apartments.find((a) => a.id === r.apartment_id)?.name || "-"
  )}
</td>


                  <td>
                    {editId === r.id ? (
                      <>
                        <button onClick={() => saveEdit(r.id)}>Save</button>
                        <button onClick={() => setEditId(null)}>Cancel</button>
                      </>
                    ) : (
                      <>
                        <button onClick={() => startEdit(r)}>Edit</button>
                        <button onClick={() => deleteReservation(r.id)}>Delete</button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
